import * as moment from "moment";
import { DismissedConflictsStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_DISMISSED_CONFLICT_STORE_DATE_RANGE', function setDismissedConflictStoreDateRange(startTime: moment.Moment, endTime: moment.Moment) {
   DismissedConflictsStore().fetchStartTime = startTime.clone();
   DismissedConflictsStore().fetchEndTime = endTime.clone();
});
